/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import styled from 'styled-components';
import { ListItem } from '../../shared/Inputs';
import {
  desktopVW,
} from '../../styles';

import { getUniqueListBy } from '../../utils';

export const UpgradeSelectors = ({
  data, products, getProducts, setProducts, totalDays, customProductArr,
} : any) => {
  const productsArr = !customProductArr ? products.filter(({ node } : { node: any }) => data.products.some(({ shopifyProduct } : { shopifyProduct: string }) => shopifyProduct === node.handle)) : customProductArr;

  const handleClick = (product: any, quantity : any) => {
    setProducts(getUniqueListBy([...getProducts, { ...product.node, quantity }], 'title'));
  };

  return (
    <StyledUpgradeSelectors>
      <ul>
        {productsArr.map((item : any) => {
          const { title, variants } = item.node;
          const [quantity, setQuantity] = useState(0);

          const selectedProduct = variants.filter((variant: any) => Number(variant.title) === parseInt(totalDays, 10))[0] || {};

          if (!selectedProduct.price) return null;

          return (
            <ListItem quantity={quantity} setQuantity={setQuantity} onClickMinus={() => { setQuantity(quantity - 1); handleClick(item, quantity - 1); }} onClick={() => { setQuantity(quantity + 1); handleClick(item, quantity + 1); }} title={title} price={`€ ${selectedProduct.price} (incl. btw)`} />
          );
        })}
      </ul>
    </StyledUpgradeSelectors>
  );
};

const StyledUpgradeSelectors = styled.div`
  margin-top: ${desktopVW(30)};
  position: relative;
`;
